import React from 'react';
import { Icon } from '../../components/Icon/Icon';
import { FairDate } from '../../services/Utils/Date';
import { ManifestDraft, ManifestReceived, ManifestSent, ManifestDeleted } from '../../constants';

export const RenderStateTitle = (state, stateUpdated) => {
  switch (state) {
    case ManifestDraft:
      return 'Draft created ' + FairDate(stateUpdated.toDate());
    case ManifestSent:
      return 'Sent ' + FairDate(stateUpdated.toDate());
    case ManifestReceived:
      return 'Received ' + FairDate(stateUpdated.toDate());
    case ManifestDeleted:
      return 'Deleted ' + FairDate(stateUpdated.toDate());
    default:
      return 'unknown state';
  }
};

export const RenderState = (state, stateUpdated) => {
  switch (state) {
    case ManifestDraft:
      return <Icon title={RenderStateTitle(state, stateUpdated)}>short_text</Icon>;
    case ManifestSent:
      return <Icon title={RenderStateTitle(state, stateUpdated)}>local_shipping</Icon>;
    case ManifestReceived:
      return <Icon title={RenderStateTitle(state, stateUpdated)}>done</Icon>;
    case ManifestDeleted:
      return <Icon title={RenderStateTitle(state, stateUpdated)}>delete_forever</Icon>;
    default:
      return <Icon>error</Icon>;
  }
};
